import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-upgrade-icon",
  "use": "icon-upgrade-icon-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-upgrade-icon\"><path fill=\"#F7A600\" d=\"M10.021 12.689H3.978a.437.437 0 1 1 0-.875h6.043a.437.437 0 1 1 0 .875Zm2.54-5.982L7.327 1.44a.437.437 0 0 0-.62 0L1.442 6.707a.438.438 0 0 0 .31.748h2.4v2.613c0 .482.392.875.875.875h3.988a.876.876 0 0 0 .875-.875V7.454h2.36a.437.437 0 0 0 .311-.747Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol